import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/common/SectionHeading";
import { fetchNews } from "@/lib/lnlApi";

export default function News() {
    const [items, setItems] = useState([]);
    const [cat, setCat] = useState("all");
    useEffect(() => { fetchNews(50).then(setItems); }, []);
    const cats = ["all", ...Array.from(new Set(items.map((i) => i.category)))];
    const filtered = cat === "all" ? items : items.filter((i) => i.category === cat);
    return (
        <div data-testid="news-page">
            <PageHero eyebrow="News & events" title="Announcements, campus news and events" description="Latest updates from Lyceum Northern Luzon." breadcrumbs={[{label:"Home",to:"/"},{label:"News & Events"}]} />
            <section className="py-10 bg-white">
                <div className="lnl-container">
                    <div className="flex flex-wrap gap-2">
                        {cats.map((c) => (
                            <button key={c} onClick={() => setCat(c)} className={`text-xs font-heading font-semibold rounded-full px-3 py-1.5 border ${cat === c ? "bg-lnl-green text-white border-lnl-green" : "bg-white text-lnl-charcoal border-lnl-border"}`} data-testid={`news-filter-${c}`}>{c}</button>
                        ))}
                    </div>
                    <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
                        {filtered.map((n) => (
                            <Link to={`/news/${n.slug}`} key={n.slug} className="lnl-card p-5 hover:border-lnl-green/40" data-testid={`news-item-${n.slug}`}>
                                <div className="lnl-eyebrow">{n.category}</div>
                                <div className="font-heading font-bold text-lg text-lnl-charcoal mt-1">{n.title}</div>
                                <div className="text-sm text-lnl-gray mt-2">{n.summary}</div>
                                <div className="mt-3 text-xs text-lnl-green-deep font-heading font-semibold inline-flex items-center gap-1">Read more <ArrowRight className="h-3.5 w-3.5" /></div>
                            </Link>
                        ))}
                        {filtered.length === 0 && <div className="text-lnl-gray col-span-full p-10 text-center border border-dashed border-lnl-border rounded-md">No items in this category yet.</div>}
                    </div>
                </div>
            </section>
        </div>
    );
}
